import { createReducer, on } from '@ngrx/store';
import { dashboardActions } from '..';
import { IDashboardState, initialState } from '../states';
import appsActionHandlersArr from './apps';
import rangeActionHandlersArr from './range';
import specialFeaturesActionHandlers from './special-features';

const EMPTY_AVERAGE_CLICK_TO_DOOR_VALUE = '00 : 00';
const DEFAULT_AMOUNT = 'N/A';

const onLoadDashboardDataSuccess = on(
  dashboardActions.loadDashboardDataSuccess,
  (state: IDashboardState, dashboardData) => ({
    ...state,
    range: {
      ...state.range,
      isLoading: false,
    },
    general: {
      ...state.general,
      ...dashboardData.general,
      averageClickToDoorTime: {
        ...dashboardData.general.averageClickToDoorTime,
        amount:
          dashboardData.general.averageClickToDoorTime.amount !== EMPTY_AVERAGE_CLICK_TO_DOOR_VALUE
            ? dashboardData.general.averageClickToDoorTime.amount
            : DEFAULT_AMOUNT,
      },
      // dashboardData.general.averageClickToDoorTime !==
      // EMPTY_AVERAGE_CLICK_TO_DOOR_VALUE
      //   ? dashboardData.general.averageClickToDoorTime
      //   : 'N/A',
    },
    exceptions: {
      ...state.exceptions,
      ...dashboardData.exceptions,
    },
    specialFeatures: {
      ...state.specialFeatures,
      ...dashboardData.specialFeatures,
    },
    carriers: {
      ...state.carriers,
      ...dashboardData.carriers,
    },
    apps: {
      ...state.apps,
      ...dashboardData.apps,
    },
  }),
);

const dashboardReducer = createReducer(
  initialState,
  onLoadDashboardDataSuccess,
  ...appsActionHandlersArr,
  ...specialFeaturesActionHandlers,
  ...rangeActionHandlersArr,
);

export { dashboardReducer };
